<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_316_2917"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="3"
      y="3"
      width="19"
      height="18"
    >
      <path d="M3.50098 3H21.501V21H3.50098V3Z" fill="white" />
    </mask>
    <g mask="url(#mask0_316_2917)">
      <path
        d="M20.9736 12.2261C20.9736 14.299 19.3091 16.0104 17.2361 16.0176C15.1585 16.0247 13.4721 14.3427 13.4721 12.2667L13.4721 12.2888C13.4721 11.75 13.0197 11.2911 12.4809 11.2911C11.9421 11.2911 11.5052 11.7279 11.5052 12.2667C11.5052 14.364 9.80927 15.9856 7.70173 15.945C5.65472 15.9055 4.02832 14.2064 4.02832 12.1591C4.02832 9.85259 5.89807 7.98284 8.20453 7.98284H16.7974C19.1039 7.98284 20.9736 9.85259 20.9736 12.1591V12.2261Z"
        class="stroke-current"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.55801 12.3109C9.55801 12.8741 8.78555 13.3306 7.83271 13.3306C6.87984 13.3306 6.10742 12.8741 6.10742 12.3109C6.10742 11.7477 6.87984 11.2912 7.83271 11.2912C8.78555 11.2912 9.55801 11.7477 9.55801 12.3109Z"
        class="stroke-current"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.8451 12.3109C18.8451 12.8741 18.0727 13.3306 17.1198 13.3306C16.1669 13.3306 15.3945 12.8741 15.3945 12.3109C15.3945 11.7477 16.1669 11.2912 17.1198 11.2912C18.0727 11.2912 18.8451 11.7477 18.8451 12.3109Z"
        class="stroke-current"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
